import React, { FC } from "react";
import { ProtectionDataContainer } from "../../../../../components/cross/data-protection/protection-data-style";
import InputBox from "../../../../../components/input-box/input-box";
import SelectBox from "../../../../../components/select-box/select-box";
import { UseFormFunctionsProps } from "../../hooks/hooks.types";
import { YES_NO_CONSTANT } from "../../../../../constants";
import { deepGet } from "../../../../../utils/utility";

const ProtectionData: FC<UseFormFunctionsProps> = ({
  values,
  errors,
  handleChange,
}) => {
  return (
    <ProtectionDataContainer>
      <div className="content-wrapper">
        <div className="personal-data-wrapper">
          <div className="personal-data-container">
            <div className="data-title" id="data-personal">
              <h5>PROTECCIÓN DE DATOS</h5>
            </div>
            <div className="personal-data-row">
              <div className="personal-data-item col-50">
                <div className="inputBox">
                  <InputBox
                    type={"text"}
                    placeholder="Fecha de consentimiento"
                    value={values.dataProtectionDetails.consentDate}
                    disabled
                  />
                </div>
              </div>

              <div className="personal-data-item col-50">
                <div className="selectBox">
                  <SelectBox
                    placeholder="Seleccionar"
                    required
                    errorCode={deepGet(errors, "dataProtection.dataTransferValue", "")}
                    iconDisabled=""
                    optionsText={YES_NO_CONSTANT}
                    optionKey={"value"}
                    optionValue={"label"}
                    initialValue={values.dataProtectionDetails.dataTransfer}
                    defaultValue={values.dataProtectionDetails.dataTransfer}
                    onChange={(value: string) => {
                      handleChange( "dataTransfer", value, "dataProtectionDetails" );
                      handleChange( "dataTransferValue", value === "S", "dataProtectionDetails" );
                    }}
                  />
                  <label>{"Cesión de datos"}</label>
                </div>
              </div>
            </div>

            <div className="personal-data-row">
              <div className="personal-data-item col-50">
                <div className="selectBox">
                  <SelectBox
                    placeholder="Seleccionar"
                    required
                    errorCode={deepGet(errors, "dataProtection.writtenAdvertisementDispatchValue", "")}
                    optionsText={YES_NO_CONSTANT}
                    optionKey={"value"}
                    optionValue={"label"}
                    initialValue={values.dataProtectionDetails.writtenAdvertisementDispatch}
                    defaultValue={values.dataProtectionDetails.writtenAdvertisementDispatch}
                    onChange={(value: string) => {
                      handleChange("writtenAdvertisementDispatch", value, "dataProtectionDetails");
                      handleChange("writtenAdvertisementDispatchValue", value === "S", "dataProtectionDetails");
                    }}
                  />
                  <label>{"Envío de publicidad escrita"}</label>
                </div>
              </div>

              <div className="personal-data-item col-50">
                <div className="selectBox">
                  <SelectBox
                    placeholder="Seleccionar"
                    required
                    errorCode={deepGet(errors, "dataProtection.productPromotionCallTransferValue", "")}
                    optionsText={YES_NO_CONSTANT}
                    optionKey={"value"}
                    optionValue={"label"}
                    initialValue={values.dataProtectionDetails.productPromotionCallTransfer}
                    defaultValue={values.dataProtectionDetails.productPromotionCallTransfer}
                    onChange={(value: string) => {
                      handleChange("productPromotionCallTransfer", value, "dataProtectionDetails");
                      handleChange("productPromotionCallTransferValue", value === "S", "dataProtectionDetails");
                    }}
                  />
                  <label>{"Cesión de llamadas promocionando productos"}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ProtectionDataContainer>
  );
};

export default ProtectionData;
